export enum ListItemType {
  Text,
  Date,
  Money,
  StrictValue,
  Separator,
}
